export default {
    topics: [
        {
            title: ' ConfirmDeletePending ',
            href: 'sm-privacyRequest-ConfirmDeletePending.html',
            attributes: { 'data-id': 'sm-gdprRequest-ConfirmDeletePending' },
            menu: { hasChildren: false },
            tocID: 'sm-gdprRequest-ConfirmDeletePending-d66e2957',
            topics: [],
        },
        {
            title: ' CreateRequestByName ',
            href: 'sm-privacyRequest-CreateRequestByName.html',
            attributes: { 'data-id': 'sm-gdprRequest-CreateRequestByName' },
            menu: { hasChildren: false },
            tocID: 'sm-gdprRequest-CreateRequestByName-d66e2965',
            topics: [],
        },
        {
            title: ' DeleteRemoteData ',
            href: 'sm-privacyRequest-DeleteRemoteData.html',
            attributes: { 'data-id': 'sm-gdprRequest-DeleteRemoteData' },
            menu: { hasChildren: false },
            tocID: 'sm-gdprRequest-DeleteRemoteData-d66e2973',
            topics: [],
        },
    ],
};

